import http from './http'

export default class PageAPI {
	//取出公有页面列表
	static publist (data) {
		return http.httpGet('/page/publist', data)
	}

	//AI取出公有页面列表
	static publist2 (data) {
		return http.httpPost('/page/publistWeb', data)
	}

	//个人项目列表
	static projlist (data) {
		return http.httpGet('/project/projlist', data)
	}

	//获取项目页面 --列表
	static projhtml (data) {
		return http.httpGet('/page/projhtml', data)
	}

	//创建项目
	static createProject (data) {
		return http.httpPost('/project/saveProjectInfo', data)
	}

	//创建落地页
	static createProjectLdy (data) {
		return http.httpPost('/project/saveProjectInfoLdy', data)
	}
	//创建落地页
	static userpageLdy (params) {
		return http.httpPut('/page/userpageLdy', null, params)
	}

	//复制项目
	static copy (data) {
		return http.httpPut('/project/copy?projId=' + data)
	}


	static updProjectStatus (data) {
		return http.httpGet('/project/updProjectStatus', data)
	}

	static shiftDelete (data) {
		return http.httpGet('/project/shiftDelete', data)
	}

	//所属行业
	static enterpriseType (data) {
		return http.httpGet('/getEnterpriseType', data)
	}

	static addLeaflet (params) {
		return http.httpPut('/page/userpage', null, params)
	}
	static imgCount (params) {
		return http.httpGet('/project/image/count', params)
	}

	//获取搜索引擎列表
	static getEnginesList (data) {
		return http.httpGet('/search/engines/list', data)
	}
	//保存搜索引擎开关
	static postSaveEngines (data) {
		return http.httpPost('/search/engines/save', data)
	}

}
